<template>
  <ponroy-pagination :value="page" @input="changeProductPage" :radius="1" :numberToShow="numberToShow" :count="count"></ponroy-pagination>
</template>

<script>
import PonroyPagination from './Pagination.vue';

import {mapActions, mapState} from 'vuex';
import store from '../store';

export default {
  name: 'ponroy-product-group',
  store,
  components: {
    PonroyPagination
  },
  computed: {
    ...mapState('facetedFilter', [
      'count',
      'numberToShow',
      'page'
    ])
  },
  methods: {
    ...mapActions('facetedFilter', [
      'changeProductPage'
    ])
  }
};
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/ProductPagination.vue